import React, { useMemo } from "react";
import { MarketHeaderProps } from "../types";
import { Grid } from "components/src/components/Grid/Grid";
import { Details } from "components/src/components/Details/Details";
import { DetailProps } from "components/src/components/Details/types";
import cx from "components/src/utils/cx";
import { tailwindSemanticColorsAsBackground as twColors } from "shared/src/styles/colorStyles";
import { spanMap, getPaddingClasses } from "../js/MarketHeaderHelpers";
import { MarketLabel } from "./MarketLabel";

const sgpDetail = { leftIcon: { name: "ui_sgp", size: "lg", color: "fg-primary-strong" }, textSize: "heading-xs", fgColor: "fg-default" } as DetailProps;

export const MarketHeaderCompact = ({
  labels = [],
  details,
  description,
  hasSGP,
  isOddsBoost,
  className,
  bg = "neutrals-transparent",
  labelTextSize = "heading-xs",
  labelTextColor = "cui-text-fg-moderate",
  descriptionTextSize = "heading-xs",
  descriptionTextColor = "cui-text-fg-default",
  paddingClasses = { left: "cui-pl-2", top: "cui-pt-1", bottom: "cui-pb-1" },
  ...rest
}: MarketHeaderProps) => {
  const numLabels = labels?.length;
  const hasDetailsArray = Array.isArray(details) && details.length > 0;
  
  if (!numLabels && typeof description !== "string" && !hasDetailsArray && !hasSGP) return null;

  const _details = useMemo(() => {
    const result = hasSGP ? [sgpDetail] : [];
    if (hasDetailsArray) {
      result.push(...details.map(d => ({ ...d, textSize: descriptionTextSize, fgColor: "fg-default" })));
    }
    return result;
  }, [hasSGP, hasDetailsArray, details, descriptionTextSize]);
  const hasDetails = _details.length > 0;

  const _classes = useMemo(() => 
    cx({ [twColors[bg]]: bg !== "none" }, `cui__market-header-compact ${getPaddingClasses(paddingClasses)} ${className ?? ''}`)
  , [bg, paddingClasses, className]);

  return (
    <Grid className={_classes} {...rest} flush>
      <Grid.Cell colSpan={spanMap[numLabels]}>
        {hasDetails ? <Details list={_details} noPad /> : typeof description === "string" ? <span className={`${descriptionTextSize} ${descriptionTextColor}`}>{description}</span> : null}
      </Grid.Cell>
      {labels.map((label, i) => (
        <MarketLabel key={`mh-compact-${i}`} label={label} index={i} isOddsBoost={isOddsBoost} isCompact textSize={labelTextSize} textColor={labelTextColor} />
      ))}
    </Grid>
  );
};
